import React from "react";
import { motion } from "framer-motion";

const COLORS = ["#16A34A", "#FF0055", "#FFD700", "#00E5FF", "#A78BFA", "#FB923C"];

// Confetti burst — bump `burst` (a number) to replay via key remount.
export function Confetti({ burst }) {
  if (!burst) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[70] overflow-hidden" key={burst} data-testid="confetti">
      {Array.from({ length: 30 }).map((_, i) => {
        const x = (Math.random() * 2 - 1) * 240;
        const y = 220 + Math.random() * 380;
        const rot = Math.random() * 720 - 360;
        const size = 7 + Math.random() * 7;
        const delay = Math.random() * 0.12;
        const c = COLORS[i % COLORS.length];
        const round = i % 3 === 0;
        return (
          <motion.span
            key={i}
            initial={{ opacity: 1, x: 0, y: 0, rotate: 0 }}
            animate={{ opacity: 0, x, y, rotate: rot }}
            transition={{ duration: 1.2 + Math.random() * 0.5, delay, ease: "easeOut" }}
            style={{ position: "absolute", left: "50%", top: "28%", width: size, height: round ? size : size * 0.5, background: c, borderRadius: round ? "50%" : 2 }}
          />
        );
      })}
    </div>
  );
}

// Floating "+amount" that rises and fades. Bump `fire` to replay.
export function FloatUp({ fire, text, color = "#16A34A" }) {
  if (!fire) return null;
  return (
    <motion.div key={fire} initial={{ opacity: 0, y: 10, scale: 0.8 }} animate={{ opacity: [0, 1, 1, 0], y: -60, scale: 1.1 }}
      transition={{ duration: 1.3, ease: "easeOut" }}
      className="pointer-events-none fixed left-1/2 top-1/3 -translate-x-1/2 z-[71] font-display text-3xl drop-shadow-lg"
      style={{ color }} data-testid="floatup">
      {text}
    </motion.div>
  );
}
